/**
 * One-time bell notices. Admin writes one adminNotices doc.
 * Closing the bell marks seen ids and clears the new-user install flag.
 */

import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../../firebase';

export const ADMIN_NOTICES_COLLECTION = 'adminNotices';

export function unseenAdminNotices(notices, seenNoticeIds) {
  const seen = seenNoticeIds && typeof seenNoticeIds === 'object' ? seenNoticeIds : {};
  return (notices || []).filter((notice) => notice?.id && seen[notice.id] !== true);
}

export function installNoticeVisible(profile) {
  return profile?.installNoticePending === true;
}

export function noticeBadgeCount(profile, notices) {
  const unseen = unseenAdminNotices(notices, profile?.seenNoticeIds);
  return unseen.length + (installNoticeVisible(profile) ? 1 : 0);
}

export function noticesSeenPatch({ noticeIds = [], clearInstall = false } = {}) {
  const patch = {};
  noticeIds.forEach((id) => {
    if (id) patch[`seenNoticeIds.${id}`] = true;
  });
  if (clearInstall) patch.installNoticePending = false;
  return patch;
}

export function subscribeAdminNotices(onNext, onError) {
  const q = query(
    collection(db, ADMIN_NOTICES_COLLECTION),
    orderBy('createdAt', 'desc'),
    limit(20)
  );
  return onSnapshot(
    q,
    (snap) => {
      onNext(snap.docs.map((row) => ({ id: row.id, ...row.data() })));
    },
    onError
  );
}

export async function markNoticesSeen(uid, { noticeIds = [], clearInstall = false } = {}) {
  const patch = noticesSeenPatch({ noticeIds, clearInstall });
  if (!uid || Object.keys(patch).length === 0) return;
  patch.updatedAt = serverTimestamp();
  await updateDoc(doc(db, 'users', uid), patch);
}
